module.exports = __webpack_public_path__ + "firework-white.a7474519c01c9301702e52358e3766b7.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/animation/firework-white.svg
// module id = 6275221555550595
// module chunks = 1